import type {InventoryStemRepository} from '@/domain/interfaces/InventoryStemRepository';

export class GetInventoryStemsByInventoryPlotUuidUseCase {
  constructor(private readonly repository: InventoryStemRepository) {}
  async execute(inventoryPlotUuid: string) {
    return this.repository.list(inventoryPlotUuid);
  }
}
